export const tokenConfig = () => ({
  headers: {
    token: `${localStorage.getItem('token')}`,
    // "Content-Type": "application/json",
  },
});
